import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: шапка лендинга попала в зону видимости.
 */
export function trackShowHeaderSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'header',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
